import { Sprout, Users, Package, MapPin } from "lucide-react";
import { Reveal } from "@/components/motion";

const items = [
  { icon: Sprout, title: "Quality Focused", text: "Carefully selected seed varieties with a focus on consistency and quality." },
  { icon: Users, title: "Farmer Focused", text: "Products designed around the needs of farming communities and agricultural partners." },
  { icon: Package, title: "Professional Packaging", text: "Branded bags — 4 kg for maize, 20 kg for wheat." },
  { icon: MapPin, title: "Bihar Focused", text: "Serving farmers, dealers, and agricultural businesses across Bihar." },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="container-site relative z-20 -mt-20 md:-mt-24">
      <Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-deep/10 rounded-3xl overflow-hidden shadow-2xl shadow-brand-deep/15 border border-brand-deep/10">
          {items.map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-brand-ivory p-7 group hover:bg-brand-beige transition-colors duration-300">
              <span className="w-11 h-11 rounded-xl bg-brand-deep/5 border border-brand-deep/10 flex items-center justify-center mb-4 group-hover:bg-brand-gold/15 group-hover:border-brand-gold/30 transition-colors">
                <Icon className="w-5 h-5 text-brand-deep" />
              </span>
              <h3 className="font-display font-bold text-brand-deep text-base">{title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-brand-charcoal/60">{text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
